import axios from 'axios';
import CryptoJS from 'crypto-js';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Bet {

  static endpoints = {
    index: `${baseUrl}/bet`,
  };

  static betType = {
    POINTS: 1,
    TOKENS: 2
  };

  static defaultStates = [
    { gameNumber: 0, betType: 1, playedNumber: 50, totalWin: 0 },
    { gameNumber: 0, betType: 2, playedNumber: 50, totalWin: 0 }
  ];

  static getStates = (states) => {
    return this.defaultStates.map((el) => {
      let receivedState = states.find(state => state.betType === el.betType);
      if(receivedState) return receivedState;
      return el;
    });
  }

  static async getAvailable() {
    return axios.get(this.endpoints.index).then((response)=> response.data.bets);
  };

  static async getBetState() {
    return axios.get(this.endpoints.index+`/bet-state`).then((response)=> response.data.states);
  };

  static async play(id, bet) {
    let hash = CryptoJS.HmacSHA256(`${bet.playedValue}:${id}:${bet.sign}`, process.env.REACT_APP_SECRET).toString();
    return axios.post(this.endpoints.index+`/${id}`, {...bet, hash}).then((response)=> response.data);
  }

  static async claim(id, token) {
    return axios.post(this.endpoints.index+`/${id}/claim`, {token: token}).then((response)=> response.data.claim);
  }

  static getRewardsValue(playedValue, playedNumber) {

    let position  = 50 - playedNumber;
    let upBonus   = 50;
    let downBonus = 50;

    upBonus   = upBonus - Math.floor((position)/2);
    downBonus = downBonus + Math.floor((position)/2);

    return [Math.floor(playedValue + (downBonus * playedValue)/100), Math.floor(playedValue + (upBonus * playedValue)/100)];
  }
}
